const Index = resolve => require(['../Index'], resolve);

export default [{
    name: 'auth.login',
    path: '/login',
    component: Index,
    meta: {
      title: 'Login',
    }
  },
];



// WEBPACK FOOTER //
// ./src/pages/auth/routes/index.js